import { ChangeEvent, useState } from 'react';
import {
  validateNewOldPasswordsMatch,
  validatePassword,
  validateRepeatPasswordsMatch,
} from '../utils/account_validations';

export function usePasswordFields() {
  const [curPassword, setCurPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [newPasswordChanged, setNewPasswordChanged] = useState(false);
  const [rePassword, setRePassword] = useState('');
  const [rePasswordChanged, setRePasswordChanged] = useState(false);
  const [curPasswordError, setCurPasswordError] = useState('');
  const [passwordValidationError, setPasswordValidationError] = useState('');
  const [matchPasswordsError, setMatchPasswordsError] = useState('');

  const isPasswordValid = Boolean(
    curPassword &&
      newPassword &&
      rePassword &&
      !curPasswordError &&
      !passwordValidationError &&
      !matchPasswordsError,
  );

  function validatePasswords(
    newOldPassword: string,
    newPassword: string,
    newRepeatPassword: string,
  ) {
    const repeatPasswordError = validateRepeatPasswordsMatch(
      newPassword,
      newRepeatPassword,
    );
    if (repeatPasswordError) {
      setMatchPasswordsError(repeatPasswordError);
    } else {
      setMatchPasswordsError('');
    }

    const passwordError = validatePassword(newPassword);
    if (passwordError) {
      setPasswordValidationError(passwordError);
      return;
    }

    const newOldPasswordError = validateNewOldPasswordsMatch(
      newPassword,
      newOldPassword,
    );
    if (newOldPasswordError) {
      setPasswordValidationError(newOldPasswordError);
      return;
    }

    setPasswordValidationError('');
  }

  function handleCurPasswordChange(e: ChangeEvent<HTMLInputElement>) {
    const newCurPassword = e.target.value;
    setCurPassword(newCurPassword);
    setCurPasswordError('');
    validatePasswords(newCurPassword, newPassword, rePassword);
  }

  function handleNewPasswordChange(e: ChangeEvent<HTMLInputElement>) {
    const password = e.target.value;
    setNewPassword(password);
    setNewPasswordChanged(true);
    validatePasswords(curPassword, password, rePassword);
  }

  function handleRepeatPasswordChange(e: ChangeEvent<HTMLInputElement>) {
    const newRepeatPassword = e.target.value;
    setRePassword(newRepeatPassword);
    setRePasswordChanged(true);
    validatePasswords(curPassword, newPassword, newRepeatPassword);
  }

  function resetPasswordFields() {
    setCurPassword('');
    setNewPassword('');
    setNewPasswordChanged(false);
    setRePassword('');
    setRePasswordChanged(false);
    setCurPasswordError('');
    setPasswordValidationError('');
    setMatchPasswordsError('');
  }

  return {
    curPassword,
    newPassword,
    newPasswordChanged,
    rePassword,
    rePasswordChanged,
    passwordValidationError,
    matchPasswordsError,
    isPasswordValid,
    curPasswordError,
    setCurPasswordError,
    handleCurPasswordChange,
    handleNewPasswordChange,
    handleRepeatPasswordChange,
    resetPasswordFields,
  };
}
